module.exports = __webpack_public_path__ + "static/media/Frontiers_in_Crop.f3c71444.pdf";